export default {
	title: 'Portefeuille',
	description: 'Tous mes projets Gerositus',
	actions: {
		back_to_this: 'Retour au portefeuille'
	},
	search_projects: 'Rechercher des projets',
	cta: {
		welcome: 'Bienvenue et merci de vous être connecté à Gerositus Strategy Suite !',
		subscribe: "S'abonner maintenant",
		create_permission: 'pour pouvoir créer de nouveaux projets.'
	},
	tabs: {
		risks: {
			title: 'Paramètres des risques et ouvertures'
		}
	},
	ownership: {
		all: 'Tous',
		owner: 'Propriétaire',
		reader: 'Lecteur'
	}
};
